import {ReactElement} from 'react';
import {init} from 'core/LifeCycle';
import {useFutureDaysCount, useKeyboardInput} from 'ui/utils/core';
import {useStateDependentAdapters} from 'ui/adapters';
import {updateOrigin} from 'ui/adapters/MessagesEmitter/messages';
import {useIsRefillEnabled} from 'ui/store/entities/CoreSettings';
import {AdapterProps} from '..';

export function useRecalcSettingsHandler(): () => void {
  const callAdapters = useStateDependentAdapters();
  const newAmount = useKeyboardInput();
  const newDaysCount = useFutureDaysCount();
  const isRefillEnabled = useIsRefillEnabled();

  return function recalcSettings(): void {
    if (newAmount <= 0) return;

    const newSettings = init(newAmount, newDaysCount, isRefillEnabled);
    callAdapters(newSettings);
    updateOrigin(newAmount, newDaysCount);
  };
}

export function RecalcSettings({children}: AdapterProps): ReactElement {
  const recalcSettings = useRecalcSettingsHandler();
  return children({recalcSettings});
}
